import { render, staticRenderFns } from "./orderdetail.vue?vue&type=template&id=cf8808c0&scoped=true"
import script from "./orderdetail.vue?vue&type=script&lang=js"
export * from "./orderdetail.vue?vue&type=script&lang=js"
import style0 from "./orderdetail.vue?vue&type=style&index=0&id=cf8808c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8808c0",
  null
  
)

export default component.exports